module.exports = __webpack_public_path__ + "static/materia-logo-dark-d0dfe3b3be17bf81436d7e561cde1d2f.png";